<template>
  <v-container fluid>
      <v-layout justify-center>
          <v-flex md12>
              <v-card title>
                  <v-card-title>
                      <h2>Asignar Permisos a Rol : {{ rol.nombre }}</h2>
                      <v-spacer></v-spacer>
                      <v-btn icon dark color="red" @click="close">
                          <v-icon>mdi-close</v-icon>
                      </v-btn>
                  </v-card-title>
                  <v-card-text>
                    <v-row dense>
                      <v-col cols="12">
                        <v-radio-group v-model="action.special" row  @change="accessGlobal">
                          <v-radio label="Acceso total" value="all-access"></v-radio>
                          <v-radio label="sin Acceso" value="no-access"></v-radio>
                          <v-radio label="Manual" value=" "></v-radio>
                        </v-radio-group>
                      </v-col>
                      <v-col cols="12">
                        <DataTableMain :datatable="table" :on-success="successAction" :itemsAction="tableAction"/>
                      </v-col>
                      <!--
                      <v-col cols="6">
                        <v-treeview
                          v-model="selection"
                          :items="items"
                          selection-type="independent"
                          selectable
                          return-object
                          :active.sync="active"
                          open-all>
                        </v-treeview>
                      </v-col>
                      -->
                    </v-row>
                  </v-card-text>
              </v-card>
          </v-flex>
      </v-layout>
  </v-container>
</template>

<script>
import { mapGetters, mapActions, mapMutations } from 'vuex'
import DataTableMain from '@/components/tables/DataTableMain'
import router from '@/router'
export default {
  data: () => ({
    table: {
      header: {
        options: [],
        titles: [
          { text: 'Id', value: 'id', class: 'black--text' },
          { text: 'Clave', value: 'slug', class: 'black--text' },
          { text: 'Nombre', value: 'nombre', class: 'black--text' },
          { text: 'Descripcion', value: 'descripcion', class: 'black--text' },
          { text: 'Activo', value: 'SwitchPermiss', class: 'black--text' }
        ],
        loading: false
      },
      body: {
        data: [],
        actions: []
      },
      footer: {
        paging: true
      }
    },
    action: {
      rol_id: 0,
      check: false,
      permiso_id: 0,
      special: ' '
    },
    permisos: [],
    rol: {},
    selection: [],
    items: []
  }),
  components: {
    DataTableMain
  },
  mounted () {
    if (this.$route.params.id) {
      this.action.rol_id = this.$route.params.id
    }
    this.getUrl('POST/config/auth/permisos/show')
  },
  methods: {
    ...mapActions(['getUrlServices', 'postServiceListAction', 'postServiceAction', 'postServiceListActionSecound']),
    ...mapMutations(['SHOW_DIALOG_MAIN', 'CLEAR_DATA_LIST']),
    successAction (item) {
      this[item.action](item)
    },
    tableAction (item) {
      this[item.action](item)
    },
    accessGlobal () {
      this.action.check = true
      this.saveActionPermission('POST/roles/set-pass')
    },
    SetActionActive (item) {
      this.action.permiso_id = item.item.id
      this.action.check = item.item.selected
      this.saveActionPermission('POST/config/auth/roles/set-permiso')
    },
    setpermissionsAssign (item) {
      this.action.permiso_id = item.id
      this.action.check = item.selected
      this.saveActionPermission('POST/roles/set-pass')
    },
    getUrl (objet) {
      this.table.header.loading = true
      if (this.get_urls != null) {
        const router = this.get_urls[objet]
        this.postServiceListAction({ url: router })
      } else {
        this.getUrlServices()
      }
    },
    getUrlRole (objet) {
      if (this.get_urls != null) {
        const router = this.get_urls[objet]
        this.postServiceListActionSecound({ url: router, data: { id: parseInt(this.action.rol_id) } })
        router.data = null
      } else {
        this.getUrlServices()
      }
    },
    saveActionPermission (objet) {
      const router = this.get_urls[objet]
      this.postServiceAction({ url: router, data: this.action })
    },
    close () {
      router.push({ name: 'ViewConfigAuthRols' })
    },
    setPermisos (permisos) {
      const items = []
      permisos.map(padre => {
        const m = { id: padre.id, name: padre.nombre }
        if (padre.sub_permisos) {
          const children = this.setSubPermisos(padre.sub_permisos)
          if (children.length > 0) m.children = children
        }
        items.push(m)
      })
      return items
    },
    setSubPermisos (permisos) {
      const subPermiso = []
      permisos.map(padre => {
        const m = { id: padre.id, name: padre.nombre }
        if (padre.sub_permisos) {
          const children = this.setSubPermisos(padre.sub_permisos)
          if (children.length > 0) m.children = children
        }
        subPermiso.push(m)
      })
      return subPermiso
    }
  },
  computed: {
    ...mapGetters(['get_dialogMain', 'get_urls', 'get_objects', 'get_object', 'get_objectsSecound'])
  },
  watch: {
    get_urls () {
      this.getUrl('POST/config/auth/permisos/show/cascada')
    },
    get_objects (vals) {
      if (vals) {
        // this.table.body.data = vals
        this.permisos = vals
        this.getUrlRole('POST/config/auth/roles/show')
      }
    },
    get_object (vals) {
      if (vals) {}
    },
    get_objectsSecound (val) {
      // this.items = this.setPermisos(this.permisos)
      if (val) {
        this.rol = val[0]
        if (this.rol.descripcion.special) {
          this.action.special = this.rol.descripcion.special
        }
        this.permisos.map(i => {
          this.rol.permisos.map(j => {
            if (i.slug === j.slug) {
              i.selected = true
            }
          })
        })

        this.table.header.loading = false
        this.table.body.data = this.permisos
      }
    }
  },
  beforeDestroy () {
    this.CLEAR_DATA_LIST()
  }

}
</script>

<style>
.switch{
    margin: 0 auto;
}
</style>
